"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _reactBicycle = require("react-bicycle");
var _react = _interopRequireWildcard(require("react"));
var _occasion = _interopRequireDefault(require("occasion"));
var _button = _interopRequireDefault(require("../../../core/button"));
var _table = _interopRequireDefault(require("../../../core/table"));
var _selectCode = _interopRequireDefault(require("../../../core/select-code"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var _ref = /*#__PURE__*/_react.default.createElement("thead", null, /*#__PURE__*/_react.default.createElement("tr", null, /*#__PURE__*/_react.default.createElement("th", {
  colSpan: "2"
}, "Ranking Database"), /*#__PURE__*/_react.default.createElement("th", {
  colSpan: "2"
}, "CanoeSlalomEntries")), /*#__PURE__*/_react.default.createElement("tr", null, /*#__PURE__*/_react.default.createElement("th", null, "Competition"), /*#__PURE__*/_react.default.createElement("th", null, "Day"), /*#__PURE__*/_react.default.createElement("th", null, "Competition"), /*#__PURE__*/_react.default.createElement("th", null, "Day"), /*#__PURE__*/_react.default.createElement("th", null)));
class MapDays extends _react.Component {
  render() {
    return /*#__PURE__*/_react.default.createElement(_table.default, null, _ref, /*#__PURE__*/_react.default.createElement("tbody", null, this.props.rdbDayMap.map(day => /*#__PURE__*/_react.default.createElement("tr", {
      key: day.id
    }, /*#__PURE__*/_react.default.createElement("td", null, day.rdbCompetitionName), /*#__PURE__*/_react.default.createElement("td", null, (0, _occasion.default)(day.rdbDayDate, 'ddd D MMM YYYY')), /*#__PURE__*/_react.default.createElement("td", null, day.competitionID ? day.competition.shortName : day.isExcluded ? '' : /*#__PURE__*/_react.default.createElement(_selectCode.default, {
      lookup: "Competitions",
      yearID: this.props.yearID,
      date: day.rdbDayDate,
      value: day.competitionID,
      onChange: this.props.onUpdate.bind(this, day.id, 'competitionID')
    })), /*#__PURE__*/_react.default.createElement("td", null, day.competitionDayID ? (0, _occasion.default)(day.competitionDay.dayDate, 'ddd D MMM YYYY') : day.isExcluded ? '' : /*#__PURE__*/_react.default.createElement(_selectCode.default, {
      lookup: "CompetitionDays",
      competitionID: day.competitionID,
      value: day.competitionDayID,
      showFullDay: true,
      onChange: this.props.onUpdate.bind(this, day.id, 'competitionDayID')
    })), /*#__PURE__*/_react.default.createElement("td", null, /*#__PURE__*/_react.default.createElement(_button.default, {
      disabled: !day.competitionID && !day.isExcluded,
      size: "sm",
      onClick: this.props.onClearMapping.bind(this, day.id)
    }, "Clear Mapping"), /*#__PURE__*/_react.default.createElement(_button.default, {
      disabled: day.isExcluded,
      size: "sm",
      onClick: this.props.onUpdate.bind(this, day.id, 'isExcluded', true)
    }, "Ignore"))))));
  }
}

// *******************************************************************************
// Data and actions
// *******************************************************************************
var _default = exports.default = (0, _reactBicycle.connect)(MapDays, undefined, (client, props) => ({
  onUpdate(id, field, value) {
    return client.update('RDBDayMap.set', {
      id,
      field,
      value
    });
  },
  onClearMapping(id) {
    return client.update('RDBDayMap.clearMappings', {
      rdbDayMapID: id
    });
  }
}));